// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"item_wrapper__232ui","background":"item_background__1RItw","image":"item_image__8W1u5","description":"item_description__12w07"};